import { render } from "./FormItem.vue?vue&type=template&id=fc6063ee&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=fc6063ee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6063ee"]])

export default __exports__